var map = {
	"./": 1376,
	"./Clutch": 2725,
	"./Clutch.js": 2725,
	"./NewUi": 2726,
	"./NewUi.js": 2726,
	"./OldUi": 2727,
	"./OldUi.js": 2727,
	"./index": 1376,
	"./index.js": 1376,
	"./style": 871,
	"./style.js": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4277;